export default "__VITE_ASSET__BRMr6sHK__"